import * as Sentry from '@sentry/remix';

import type { UserProfile } from '~/user/Profile';
import { sha256 } from '~/utils/hash';

export type TikTokServerEventData = {
  context: {
    ip: string | null;
    page: { url: string };
    user_agent: string;
  };
  event: string;
  event_id: string;
  event_time: number;
  properties?: Record<string, unknown>;
  user: {
    email?: string;
    external_id?: string;
    phone_number?: string;
    ttclid?: string;
    ttp?: string;
  };
}[];

async function sendServerEvent(
  data: TikTokServerEventData,
  pixelCode: string,
  accessToken: string
) {
  try {
    const response = await fetch(
      'https://business-api.tiktok.com/open_api/v1.3/event/track/',
      {
        body: JSON.stringify({
          data,
          event_source: 'web',
          event_source_id: pixelCode
        }),
        headers: {
          'Access-Token': accessToken,
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }
    );

    if (!response.ok) {
      const body = await response.text();

      Sentry.captureException(
        new Error(`TikTok Events API error: ${response.status}`),
        { extra: { body, message: 'Error sending TikTok server event' } }
      );
    }
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Error sending TikTok server event' }
    });
  }
}

export async function getHashedProfile(profile?: UserProfile) {
  if (!profile) return {};

  const [email, phone_number] = await Promise.all([
    sha256(profile.email),
    sha256(profile.phone_number)
  ]);

  return { email, phone_number };
}

export default { getHashedProfile, sendServerEvent };
